import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Layout from '../Layout';
import ForgotPasswordForm from './ForgotPasswordForm2';
import {forgotPasswordRequestAction, forgotPasswordClearRequestFailure} from './redux2';
import {datadogRum} from "@datadog/browser-rum";
import {replace} from "react-router-redux";
import {forgotPasswordOtpTypeUrl} from "../../utils/url/forgotPasswordOtpTypeUrl";
import mixpanelService from '../../services/mixpanel';
import {reset} from 'redux-form';

@connect(
  state => {
    return {
      requestStatus: state.authRoot.forgotPassword.status,
      failReason: state.authRoot.forgotPassword.failReason,
      isLoadingFPRequest: state.authRoot.forgotPassword.isLoadingFPRequest,
      isFPRequestSuccess: state.authRoot.forgotPassword.isFPRequestSuccess,
      isFPRequestFail: state.authRoot.forgotPassword.isFPRequestFail,
      error: state.authRoot.forgotPassword.fPError,
      isFullSsnValidationRequired: state.authRoot.forgotPassword.isFullSsnValidationRequired,
    };
  },
  dispatch => ({
    forgotPasswordRequestAction: (ssn4Digits, userName, userNameType) => dispatch(forgotPasswordRequestAction(ssn4Digits, userName, userNameType)),
    redirect: (path) => dispatch(replace(path)),
    clearRequestFailure: () => {
      dispatch(forgotPasswordClearRequestFailure());
      dispatch(reset('forgotPassword'));
    },
  })
)
class ForgotPasswordController extends React.Component {

  static propTypes = {
    requestStatus: PropTypes.string,
    isFPRequestSuccess: PropTypes.bool,
    isFPRequestFail: PropTypes.bool,
    error: PropTypes.object,
    failReason: PropTypes.string,
    forgotPasswordRequestAction: PropTypes.func.isRequired,
    redirect: PropTypes.func.isRequired,
    clearRequestFailure: PropTypes.func.isRequired,
    isFullSsnValidationRequired: PropTypes.bool,
  };

  componentDidUpdate(prevProps) {
    const { isFPRequestSuccess, isFPRequestFail, error} = this.props;
    if (!prevProps.isFPRequestSuccess && isFPRequestSuccess) {
      datadogRum.addUserAction('Forgot password start success', {});
      mixpanelService.track('OTP forgot password', {step: 'start forgot password success'});
      this.props.redirect(forgotPasswordOtpTypeUrl());
    }
    if (!prevProps.isFPRequestFail && isFPRequestFail) {
      datadogRum.addUserAction('Forgot password start failed', { error });
      mixpanelService.track('OTP forgot password', {step: 'start forgot password failed'});
    }
  }

  handleSubmit(ssn4Digits, email) {
    const {forgotPasswordRequestAction} = this.props;
    const userNameType = 'EMAIL';
    forgotPasswordRequestAction(ssn4Digits, email, userNameType);
  }

  render() {
    const { requestStatus, failReason} = this.props;

    return (
      <Layout>
        <ForgotPasswordForm 
          submitCallback={(ssn4Digits, email) => this.handleSubmit(ssn4Digits, email)} 
          status={requestStatus} 
          failReason={failReason} 
          clearRequestFailure={this.props.clearRequestFailure}
          isFullSsnValidationRequired={this.props.isFullSsnValidationRequired}
        />
      </Layout>
    );

  }
}

export default ForgotPasswordController;



// WEBPACK FOOTER //
// ./src/auth/authWithOtp/ForgotPasswordController2.js